import { fetchAuthSession } from 'aws-amplify/auth'

const API_HOST = import.meta.env.VITE_SERVICE_URL

export async function getAuthHeader() {
    const session = await fetchAuthSession()
    return {
        // https://docs.amplify.aws/vue/build-a-backend/auth/connect-your-frontend/manage-user-sessions/#refreshing-sessions
        // https://docs.amplify.aws/vue/build-a-backend/add-aws-services/rest-api/customize-authz/#cognito-user-pool-authorization
        // https://docs.amplify.aws/react/build-a-backend/auth/concepts/tokens-and-credentials/
        Authorization: `Bearer ${session.tokens?.idToken}`,
    }
}

export async function fetchFromApi(urlPath: string, method: string='GET', body?: object) {
    let data = null
    let error = null
    let status_code = null

    if (!urlPath.startsWith('/')) {
        throw new Error('urlPath must start with /')
    }

    const url = `${API_HOST}${urlPath}`

    try {
        const response = await fetch(url, {
            method,
            mode: 'cors',
            credentials: 'include',
            headers: {
                ...await getAuthHeader(),
                'Content-Type': 'application/json',
            },
            ...( body ? {body: JSON.stringify(body)} : {} )
        })

        if (response.ok === true) {
            data = await response.json()
        } else if (response.status >= 500) {
            try {
                // Try to parse the error as json
                error = await response.json()
                error = error.detail
            } catch (e) {
                console.error(e)
                error = 'An unexpected error has occurred. Please try again shortly, or contact us if the issue persists.'
            }

        } else {
            error = await response.json()
            if ('detail' in error) {
                error = error.detail
            }
        }

        status_code = response.status
        
    } catch (e) {
        console.error(e)

        if (e instanceof Error && e.message === 'Failed to fetch') {
            // determine if it's client or server
            if (navigator.onLine === false) {
                error = 'Network Error - please check your connection and refresh the page.'
            } else {
                error = 'Unable to connect to server. Please try again shortly.'
            }
        } else if (e instanceof TypeError) {
            // if (e.message.startsWith('NetworkError')) {

            //   // TODO distinguish between server error and internet connection error
            //   error = 'Network Error - please check your connection and refresh the page.'

            // } else {
              error = 'An error occurred. Please try again shortly, or contact us if the issue persists at team@the-odds-api.com'

            // }
        } else {
            console.error('Unexpected error:', e)
            error = 'An unexpected error has occurred. Please try again shortly, or contact us if the issue persists at team@the-odds-api.com'
        }
    }

    return { data, status_code, error }
}
